<div class="root tw-switch" :class="{ active: modelValue, 'switch-off': off }" @click.stop.prevent="onClick">
  <input role="checkbox" type="checkbox" :checked="modelValue" />
</div>
